module.exports = __webpack_public_path__ + "img/MM-OLIVE.gif";